import getJwtPayload from '../getJwtPayload';
import generateKey from '../generateKey';

const getUrlWithCacheBusterFromJwt = (url, jwt) => {
  const hashFromUserId = generateKey(getJwtPayload(jwt).sub);
  if (url.includes('?')) {
    return url.concat(`&cb=${hashFromUserId}`);
  }

  return `${url}?cb=${hashFromUserId}`;
};

export default getUrlWithCacheBusterFromJwt;
